"use client";

import { Alert, AlertTitle } from "@/components/ui/Alert";
import {
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";
import { Button } from "@/ui/Button";
import { useTranslation } from "react-i18next";
import { FaCheckCircle } from "react-icons/fa";
import { MdGpsFixed } from "react-icons/md";
import { toast } from "sonner";

const GetLocation = ({
  selectedLocation,
  isLoading,
  setSelectedLocation,
  handleSubmit,
}) => {
  const { t } = useTranslation("register");
  const getUserLocationAutomatically = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          setSelectedLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          toast.success(t("location_detected_success"));
        },
        error => {
          toast.error(t("location_error"));
        },
        { enableHighAccuracy: true }
      );
    } else {
      toast.error(t("browser_support_error"));
    }
  };

  return (
    <>
      <DialogHeader className="sm:text-right">
        <DialogTitle className="text-foreground text-center">
          {t("location_verification")}
        </DialogTitle>
      </DialogHeader>

      <>
        <DialogDescription className="text-muted-foreground text-center">
          <Button
            onClick={getUserLocationAutomatically}
            variant="outline"
            size="sm"
            className="mb-1 text-foreground w-fit mt-4 flex mx-auto"
          >
            {t("location_auto_detected_button")}
            <MdGpsFixed className="text-[1.2rem]" />
          </Button>
        </DialogDescription>

        <div
          className={`transition-[opacity,height,transform,margin] duration-500 ease-in-out transform ${
            selectedLocation
              ? "opacity-100 scale-100 h-auto mb-4"
              : "opacity-0 scale-0 h-0"
          }`}
        >
          <Alert variant="success" className="text-sm p-3 [&>svg]:top-3">
            <FaCheckCircle className="w-4 h-4 top-0" />
            <AlertTitle className="mb-0 !ps-8">
              {t("location_detected_success")}
            </AlertTitle>
          </Alert>
        </div>
      </>

      <DialogFooter className="!flex-col-reverse">
        <Button
          disabled={!selectedLocation}
          isLoading={isLoading}
          onClick={handleSubmit}
          className="w-full"
        >
          {t("continue_button")}
        </Button>
      </DialogFooter>
    </>
  );
};

export default GetLocation;
